import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { useRoute } from 'vue-router'

export const useCounterStore = defineStore('counter', () => {
  // menu 菜单项
  const menu = ref([
    // {
    //   key:'/systemSettings',
    //   path:'/systemSettings',
    //   label:'系统设置',
    //   title:'系统设置',
    //   permission:'manage',
    //   iconFontActive:require('@/assets/imgs/settingsActive.png'),
    //   iconFont:require('@/assets/imgs/settings.png'),
    //   children:[
    //     {
    //       key:'/accountManage',
    //       path:'/accountManage',
    //       label:'账号管理',
    //       title:'账号管理',
    //       permission:'manage',
    //     },
    //     {
    //       key:'/parameterSetup',
    //       path:'/parameterSetup',
    //       label:'参数设置',
    //       title:'参数设置',
    //       permission:'manage',
    //     },
    //   ]
    // },
    // {
    //   key:'/physicalExaminationManage',
    //   path:'/physicalExaminationManage',
    //   label:'体检管理',
    //   title:'体检管理',
    //   permission:'manage',
    //   iconFontActive:require('@/assets/imgs/examinationActive.png'),
    //   iconFont:require('@/assets/imgs/examination.png'),
    //   children:[
    //     {
    //       key:'/studentList',
    //       path:'/studentList',
    //       label:'学生名单',
    //       title:'学生名单',
    //       permission:'manage',
    //     },
    //   ]
    // },
  ])
  // 首页菜单项
  const menuHome = ref({})
  // 当前菜单选中项
  const selectedKey = ref({
    openKey:[],
    activeKey:[]
  })
  const route=useRoute()
  const getKeys=(item)=>{
    const fullPath =item|| route.fullPath.indexOf('?')
    const lastPath =item|| route.fullPath.slice(0,fullPath)
    if(fullPath!=-1){
      menu.value.forEach(value=>{
        value.children?.forEach(val=>{
          if(val.path===lastPath){
            selectedKey.value.openKey=[value.path]
          }
        })
      })
      selectedKey.value.activeKey=[lastPath]
      sessionStorage.setItem('openKey',JSON.stringify(selectedKey.value))
    }else{

      menu.value.forEach(value=>{
        value.children?.forEach(val=>{
          if(val.path===route.fullPath){
            selectedKey.value.openKey=[value.path]
          }
        })
      })
      selectedKey.value.activeKey=[route.fullPath]
      sessionStorage.setItem('openKey',JSON.stringify(selectedKey.value))
    }
  }
  const count = 0
  const doubleCount = computed(() => count * 2)
  function increment() {
    
  }
  // 初始化菜单
  const initializeMenu = () => {
    const permission = JSON.parse(sessionStorage.getItem('permissions')) 
    menu.value.forEach((item) => {
          item.show = true
        // if ((permission || [])?.includes(item.permission)) {
        // } else {
        //     item.show = false
        // }
        if (item.children?.length) {
            item.children.forEach((child) => {
                    child.show = true

                // if ((permission || [])?.includes(child.permission)) {
                //     child.show = true
                // } else {
                //     child.show = false
                // }
            })
        }
    })
  }
  const initializeHome = ()=>{
    const permission = JSON.parse(sessionStorage.getItem('permissions')) 
    // menuHome.value.systemSettings.forEach(item=>{
    //   if ((permission || [])?.includes(item.permission)) {
    //       item.show = true
    //   } else {
    //       item.show = false
    //   }
    // })
    // menuHome.value.systemSettings=menuHome.value.systemSettings.filter(item=>(permission || [])?.includes(item.permission)) 
  }
  // 过度编辑
  const spinning = ref(false)
  return { 
    count, 
    doubleCount, 
    increment,
    getKeys,
    menu, 
    menuHome,
    selectedKey,
    spinning,
    initializeMenu,
    initializeHome
  }
})
